export default __webpack_public_path__ + "static/media/localShippingLight.a189f0aa.svg";